import React, { createContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";

const RequestDataContext = createContext();

export function RequestDataHolder({ settings, children }) {
  const userId = useSelector((state) => state.account.user?.id);
  const [requestState, setRequestState] = useState({ userId, data: {} });
  const previousUserId = useRef(userId);
  const requestData = requestState.userId === userId ? requestState.data : {};

  useEffect(() => {
    if (previousUserId.current !== userId) {
      setRequestState({ userId, data: {} });
      previousUserId.current = userId;
    }
  }, [userId]);

  const saveRequestData = (updatedData) => {
    setRequestState((previousState) => ({
      userId,
      data: {
        ...(previousState.userId === userId ? previousState.data : {}),
        ...updatedData,
      },
    }));
  };

  const clearRequestData = () => {
    setRequestState({ userId, data: {} });
  };

  return (
    <RequestDataContext.Provider
      value={{
        requestData,
        saveRequestData,
        clearRequestData,
      }}
    >
      {children}
    </RequestDataContext.Provider>
  );
}

RequestDataHolder.propTypes = {
  children: PropTypes.node.isRequired,
  settings: PropTypes.object,
};

export const RequestDataConsumer = RequestDataContext.Consumer;

export default RequestDataContext;
